import * as React from 'react'

/**
 * stores a value in a ref object that is returned
 * and whenever the provided value changes, the ref inner value is updated
 *
 * this can be useful when we need to always read the latest value but do not want to trigger rerender when that value changes
 */
export const useUpdatedRef = <TRefType>(storedValue: TRefType) => {
  // store the provided value in React ref object
  const ref = React.useRef<TRefType>(storedValue)

  // connect update effect that will keep the refs inner (`current`) value up to date with the `storedValue`
  React.useEffect(() => {
    ref.current = storedValue
  }, [storedValue])

  // return the ref object
  return ref
}
